require('es6-promise').polyfill()
require('isomorphic-fetch')
import { initialState } from '../../store/configure_store.js'

export const authenticatedRequest = (params = {}) => {
  const { url, method = 'GET', headers = {} } = params
  return (dispatch, getState) => {
    const {api_token, client_install, client_version } = getState().data.config
    return fetch(url, {
      method,
      headers: new Headers({
        Authorization: `Token=${api_token}`,
        [`Client-Install`]: client_install,
        [`Client-Version`]: client_version,
        ...headers
      })
    })
  }
}

export const fetchLoans = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: '/api/v1/loans'}))
      .then(resp => resp.json())
      .then(({loans = []}) => dispatch({type: `RECEIVE_LOANS`, loans}) && loans )
  }
}

export const fetchProducts = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: '/api/v1/products'}))
      .then(resp => resp.json())
      .then(({loans = [], credit_card_accounts = []}) => dispatch({type: `RECEIVE_PRODUCTS`, loans, credit_card_accounts}) && { loans, credit_card_accounts })
  }
}

export const fetchCreditCardAccounts = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: '/api/v1/credit_card_accounts'}))
      .then(resp => resp.json())
      .then(({credit_card_accounts = []}) => dispatch({type: `RECEIVE_CREDIT_CARD_ACCOUNTS`, credit_card_accounts}) && credit_card_accounts)
  }
}

export const fetchCustomerNotices = (customer_id) => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: `/api/v1/customers/${customer_id}/notices`}))
      .then(resp => resp.json())
      .then(({notices = []}) => dispatch({type: `RECEIVE_NOTICES`, notices}) && notices )
  }
}

export const fetchNotices = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: `/api/v1/notices`}))
      .then(resp => resp.json())
      .then(({notices = []}) => dispatch({type: `RECEIVE_WORKFLOW_NOTICES`, notices}) && notices )
  }
}

export const fetchOpenCustomerApplications = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: '/api/v1/customer_applications?status=open'}))
      .then(resp => resp.json())
      .then(({customer_applications = []}) => {
        dispatch({type: `RECEIVE_CUSTOMER_APPLICATIONS`, customer_applications})
      })
  }
}

export const fetchClosedCustomerApplications = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: '/api/v1/customer_applications?status=closed&product_filter=exclude_post_issuance&within_days=30&has_viewed_application=true'}))
      .then(resp => resp.json())
      .then(({customer_applications = []}) => {
        dispatch({type: `RECEIVE_CUSTOMER_APPLICATIONS`, customer_applications})
      })
  }
}

export const fetchActionablePayment = (loan_id) => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: `/api/v1/loans/${loan_id}/actionable_payment`}))
      .then(resp => resp.json())
      .then(({payment}) => payment)
      .catch(() => null)
  }
}

export const fetchCustomer = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: `/api/v1/customers/${getState().data.customer.id}`}))
      .then(resp => resp.json())
      .then(({customer = {}}) => dispatch({type: `RECEIVE_CUSTOMER`, customer}) && customer )
  }
}

export const fetchBankAccount = () => {
  return (dispatch, getState) => {
    return dispatch(authenticatedRequest({url: `/api/v1/customers/${getState().data.customer.id}/bank_account`}))
      .then(resp => resp.json())
      .then(({bank_account = {}}) => dispatch({type: `RECEIVE_BANK_ACCOUNT`, bank_account}) && bank_account )
      .catch(() => null)
  }
}

export const incrementLoading = () => {
  return(dispatch, getState) => {
    return dispatch({type: `INCREMENT_LOADING`})
  }
}

export const decrementLoading = () => {
  return(dispatch, getState) => {
    return dispatch({type: `DECREMENT_LOADING`})
  }
}

export const fetchCustomerHomeData = () => {
  return (dispatch, getState) => {
    const data = [
      dispatch(fetchCustomer()),
      dispatch(fetchOpenCustomerApplications()),
      dispatch(fetchClosedCustomerApplications()),
      dispatch(fetchCustomerNotices(getState().data.customer.id)),
      dispatch(fetchNotices()),
      dispatch(fetchBankAccount()),
      dispatch(fetchProducts())
        .then(({ loans }) => loans.map(l => l.id))
        .then(ids   => ids.map(id => dispatch(fetchActionablePayment(id))))
        .then(appromises => Promise.all(appromises))
        .then(actionable_payments => dispatch({
          type: `RECEIVE_ACTIONABLE_PAYMENTS`,
          actionable_payments: actionable_payments.filter(p => p !== null)})
        ),
    ].map(promise => {
      dispatch(incrementLoading())
      return promise
        .then(data => dispatch(decrementLoading()) && data)
        .catch(err => dispatch(decrementLoading()) && Promise.reject(err))
    })
    return Promise.all(data)
  }
}

export const loginCustomer = ({email, password}) => {
  return (dispatch, getState) => {
    const { client_version } = getState().data.config
    return fetch(`/api/v1/login`, {
      method: 'POST',
      body: JSON.stringify({
        email,
        password
      }),
      headers: new Headers({
        [`Content-Type`]:   'application/json',
        [`Client-Version`]: client_version
      })
    })
    .then(resp => resp.json())
    .then(({customer, authentication_token, client_install: {uuid} = {}}) => {
      dispatch({type: `CLEAR_STATE`, initialState: initialState.data})
      dispatch({type: `RECEIVE_AUTHENTICATION`, client_version, api_token: authentication_token, client_install: uuid})
      return dispatch({type: `RECEIVE_CUSTOMER`, customer})
    })
    .then(_ => {
      return dispatch(fetchProducts())
        .then(({ loans }) => loans.map(l => l.id))
        .then(ids   => ids.map(id => dispatch(fetchActionablePayment(id))))
        .then(appromises => Promise.all(appromises))
        .then(actionable_payments => dispatch({type: `RECEIVE_ACTIONABLE_PAYMENTS`, actionable_payments: actionable_payments.filter(p => p !== null)}))
    })
    .then(_ => dispatch(fetchOpenCustomerApplications()))
    .then(_ => dispatch(fetchClosedCustomerApplications()))
    .then(_ => dispatch(fetchCustomerNotices(getState().data.customer.id)))
    .then(_ => dispatch(fetchNotices()))
  }
}
